
/* eslint-disable */

// Fetch: get articles from backend
import axios from "axios";
import { reactive } from "vue";
import { watch } from "vue";


// Firebase: get preferences
import { preferencesState } from "@/store/preferencesStore";
import { onAuthStateChanged, getAuth } from "firebase/auth";
const auth = getAuth();

// API Location
let API_URL =
  window.location.hostname === 'app.lwyr.ca'
    ? 'https://api.lwyr.ca'
    //: 'http://localhost:3000'
    :`http://${window.location.hostname}:3000`

//API_URL = 'https://api.lwyr.news'

 
//------------------------------------------------------------
//  Helper functions
//------------------------------------------------------------
  function randomNum() {
    return Math.floor(Math.random() * 7) + 1;
  }

  function parseJsonArray(value) {
    if (Array.isArray(value)) return value;
    if (!value) return [];

    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  // mapping 
  const mapArticles = data =>
    data.map(a => ({
      id: a.id,
      title: a.title,
      ///description: a.summary || a.description || "",
      description: a.summary || a.description || "",
      body: a.body || "",
      urlToImage: a.image_url?.trim()
      ? a.image_url
      : `https://lwyr.ca/img/stock/${randomNum()}.jpg`,
      url: a.link,
      author: a.author,
      source: a.source_name,
      name: a.source_name,
      type: a.type,
      ai_summary: a.ai_summary || "",
      tag_practice_area: parseJsonArray(a.tag_practice_area),
      tag_industry: a.tag_industry || [],
      tag_jurisdiction: a.tag_jurisdiction || [],
      published: a.published || 'no date',
      views: a.views
  }))

 
//------------------------------------------------------------
//  End Helper functions
//------------------------------------------------------------













 
// Function to pull articles
export const articleState = reactive({
  articles: [],     // stores articles based on preferences
  articlesAll: [],  // pulls all articles for filtering (for x days)
  isLoaded: false,
  isLoading: false,

  async loadArticles() {

   
    // 1. Check localStorage cache
    /*
    const cached = localStorage.getItem("articles-cache");
    if (!this.isLoaded && cached) {
      try {
        this.articles = JSON.parse(cached);
        this.isLoaded = true;
        return this.articles;
      } catch (e) {
        console.warn("Bad cache, ignoring...");
      }
    }
    */
    

    // 2. Avoid double fetch
    if (this.isLoading) return this.articles;

    // 3. If already loaded in this session
    if (this.isLoaded) return this.articles;

    this.isLoading = true;

    try {
        //console.log("SOURCES:", preferencesState.sources);

        //console.log("BOokmarks test2:::",  preferencesState.bookmarks);
        const payload = {
          //tags: ["regulatory compliance"],
          //jurisdiction: "canada (general)",
          //industry: "construction",
          //source_id: ["ca_journal_ohlj", "ca_blog_blg"],

          tags: preferencesState.topics,
          source_id: preferencesState.sources,
          jurisdiction: preferencesState.jurisdictions,
          industry: preferencesState.industries,

          //source_id: ["ca_journal_ubclr"],
          limit: 100
        };


        const [personalRes, globalRes] = await Promise.all([
          axios.post(`${API_URL}/api/search`, payload),
          axios.get(`${API_URL}/api/global?days=99`)
        ])
        this.articles = mapArticles(personalRes.data)
        this.articlesAll = mapArticles(globalRes.data)
        console.log('articlesAll length'+ this.articlesAll.length);

 
        /*
        //const response = await axios.post(`${API_URL}/api/search`, payload);

 
        // const data = response.data;
        //this.articles = data; // show results on page




        this.articles = data.map(a => ({
          id: a.id,
          title: a.title,
          description: a.summary || a.description || "",
          body: a.body || "test",
          urlToImage: a.image_url,
          url: a.link,
          author: a.author,
          source: a.source_name,
          name: a.source_name,
          type: a.type,
          ai_summary: a.ai_summary || "test",
          tag_practice_area: JSON.parse(a.tag_practice_area) || [],
          tag_industry: a.tag_industry || [],
          tag_jurisdiction: a.tag_jurisdiction || [],
        }));

        */


        this.isLoaded = true;

        // 4. Save to localStorage
        //localStorage.setItem("articles-cache", JSON.stringify(data));
        localStorage.setItem("articles-cache", JSON.stringify(personalRes.data));

        //return data;
        return personalRes.data;
    } 
    finally {
      this.isLoading = false;
    }
  }
});





// If user logged in, pull
onAuthStateChanged(auth, async user => {
  if (user) {
    await preferencesState.load(user);
    console.log("Preferences loaded — now loading articles");
    await articleState.loadArticles();




    // refresh hourly
    setInterval(async () => {
      articleState.isLoaded = false;
      await articleState.loadArticles();
      console.log("Hourly refresh");
    }, 60 * 60 * 1000); // 1 hour
  }
});





// Reloads loadArticles on prefernces change
watch(
  () => [
    preferencesState.sources,
    preferencesState.topics,
    preferencesState.jurisdictions,
    preferencesState.industries
  ],
  async () => {
    console.log("Preferences changed → reloading articles...");
    
    // reset loading flags
    articleState.isLoaded = false;

    await articleState.loadArticles();
  },
  { deep: true }
);




















//http://64.23.169.14/api/search

      /*
      const res = await fetch("http://localhost:3000/api/articles");
      const data = await res.json();
      this.articles = data;
      */

        //test
        //console.log("Loading sources in article.store:", JSON.parse(JSON.stringify(preferencesState.sources)));
       // console.log("Loading topics in article.store:", JSON.parse(JSON.stringify(preferencesState.topics)));
        //console.log("Raw preferencesState.sources:", preferencesState.sources);
        //console.log("Type:", typeof preferencesState.sources);
